import { css } from 'styled-components'

export const inProgressStyleMixin = css`
  cursor: progress;
  opacity: 0.8;

  & > * {
    pointer-events: none;
  }
`
